export default {
  id: null,
  companyID: null,
  name: null,
  code: null,
  acronym: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/bankmodel.js